import React, { useState, useEffect, useRef } from "react";
import "@/App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route, Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent } from "@/components/ui/card";
import { Toaster, toast } from "sonner";
import {
  Phone,
  Mail,
  ChevronRight,
  ChevronLeft,
  Star,
  Sparkles,
  Menu,
  X,
  ArrowRight,
  ArrowLeft,
  Check,
  Send } from
"lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Services data with full details
const services = [
{
  id: 1,
  slug: "new-year",
  title: "Новогоднее оформление",
  description: "Входная группа, витрина, фасад, фотозона. Хвоя, огни, композиции, монтаж и демонтаж.",
  image: "/images/photo4.jpeg",
  color: "from-emerald-800 to-emerald-900",
  large: true,
  fullDescription: `Новогоднее оформление — это не просто декор, это создание волшебной атмосферы, которая привлекает посетителей и создаёт незабываемые впечатления.

Мы создаём уникальные новогодние композиции для витрин, входных групп и фасадов. Используем качественные материалы: искусственные ели, гирлянды, световые элементы, шары, снежинки и авторские элементы декора.

Что входит в услугу:
• Разработка индивидуальной концепции
• 3D-визуализация проекта
• Подбор и закупка материалов
• Профессиональный монтаж
• Демонтаж после праздников`,
  gallery: [
  "/images/photo2.jpeg",
  "/images/photo1.jpeg",
  "/images/photo3.jpeg"],

},
{
  id: 2,
  slug: "march-8",
  title: "8 Марта",
  description: "Нежный весенний декор в фирменных цветах. Акцент на витрину и вход, чтобы привлекать внимание с улицы.",
  image: "/images/photo8.jpeg",
  color: "from-pink-600 to-rose-700",
  fullDescription: `Оформление к 8 Марта — это нежность, цветы и весеннее настроение. Мы создаём романтичные композиции, которые подчеркнут особенность вашего заведения в этот прекрасный праздник.

Используем живые и искусственные цветы, нежные ткани, световые элементы и авторские декоративные композиции в розовых, белых и пастельных тонах.

Что входит в услугу:
• Флористические композиции
• Декорирование входной группы
• Оформление витрин
• Тематические инсталляции
• Световое оформление`,
  gallery: [
  "/images/photo8.jpeg",
  "/images/photo9.jpeg",
  "/images/photo6.jpeg"],

},
{
  id: 3,
  slug: "easter",
  title: "Пасхальный декор",
  description: "Светлые композиции в пастельных тонах. Венки, декоративные элементы, аккуратная подсветка.",
  image: "https://images.unsplash.com/photo-1758919452252-7c96d76d9217?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxzcHJpbmclMjBmbG9yYWwlMjBmYWNhZGUlMjBkZWNvcmF0aW9uJTIwc2hvcHxlbnwwfHx8fDE3Njk3OTc0MTd8MA&ixlib=rb-4.1.0&q=85",
  color: "from-amber-500 to-orange-600",
  fullDescription: `Пасхальное оформление — это светлый и радостный декор, который создаёт атмосферу весеннего праздника. Мы используем традиционную символику в современном прочтении.

Пастельные тона, цветочные композиции, декоративные яйца, кролики и весенние мотивы — всё это создаёт неповторимую праздничную атмосферу.

Что входит в услугу:
• Тематические инсталляции
• Декоративные композиции с пасхальной символикой
• Флористическое оформление
• Витринные композиции
• Световые акценты`,
  gallery: [
  "https://images.unsplash.com/photo-1761396742176-b6a5f17f9620?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxlYXN0ZXIlMjBwYXN0ZWwlMjBkZWNvcmF0aW9uJTIwc2hvcCUyMHdpbmRvd3xlbnwwfHx8fDE3Njk3OTk2MTh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1712003154729-7298c2bea993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxlYXN0ZXIlMjBwYXN0ZWwlMjBkZWNvcmF0aW9uJTIwc2hvcCUyMHdpbmRvd3xlbnwwfHx8fDE3Njk3OTk2MTh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1741746505413-dc50435948eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxzcHJpbmclMjBmbG93ZXJzJTIwc2hvcCUyMGZhY2FkZSUyMGRlY29yYXRpb258ZW58MHx8fHwxNzY5Nzk5NjE0fDA&ixlib=rb-4.1.0&q=85"],

},
{
  id: 4,
  slug: "events",
  title: "Оформление мероприятий",
  description: "Цветочные арки, входные группы, фотозоны и декор залов. Создаём атмосферу, о которой мечтают.",
  image: "https://images.unsplash.com/photo-1757589227072-0dd17af42433?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwdmVudWUlMjBlbnRyYW5jZSUyMGZsb3JhbCUyMGFyY2glMjBkZWNvcmF0aW9uJTIwZWxlZ2FudHxlbnwwfHx8fDE3Nzg1NzczNDF8MA&ixlib=rb-4.1.0&q=85",
  color: "from-rose-400 to-pink-600",
  fullDescription: `Декор мероприятия — это первое, что задаёт тон всему событию. Мы берём на себя оформление входной группы, основного зала, фотозон и лаунж-пространств — от концепции до монтажа в день мероприятия. Каждый проект создаётся индивидуально: мы учитываем формат, стилистику, палитру, особенности площадки и пожелания заказчика.

Что входит в услугу:
• Цветочные арки и декоративные композиции
• Оформление входной группы и зоны встречи гостей
• Декор основного зала — столы, сцена, потолочные инсталляции
• Фотозоны и тематические уголки
• Световой декор и свечи`,
  gallery: [
  "https://images.unsplash.com/photo-1757589166064-ef528f309c94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwdmVudWUlMjBlbnRyYW5jZSUyMGZsb3JhbCUyMGFyY2glMjBkZWNvcmF0aW9uJTIwZWxlZ2FudHxlbnwwfHx8fDE3Nzg1NzczNDF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1769812343890-4e406a33cfbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHx3ZWRkaW5nJTIwdmVudWUlMjBlbnRyYW5jZSUyMGZsb3JhbCUyMGFyY2glMjBkZWNvcmF0aW9uJTIwZWxlZ2FudHxlbnwwfHx8fDE3Nzg1NzczNDF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1775880307852-de22d32eb79f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwdmVudWUlMjBlbnRyYW5jZSUyMGZsb3JhbCUyMGFyY2glMjBkZWNvcmF0aW9uJTIwZWxlZ2FudHxlbnwwfHx8fDE3Nzg1NzczNDF8MA&ixlib=rb-4.1.0&q=85"],

},
{
  id: 5,
  slug: "summer",
  title: "Летний декор",
  description: "Вход, витрина, терраса. Зелень, гирлянды, легкие композиции, фототочки для гостей.",
  image: "/images/photo15.jpeg",
  color: "from-sky-500 to-blue-600",
  large: true,
  fullDescription: `Летнее оформление — это яркие краски, живые цветы и свежесть. Идеально подходит для террас ресторанов, летних кафе и магазинов, которые хотят привлечь внимание прохожих.

Мы создаём композиции с использованием ярких цветов, зелени, декоративных элементов в морском, тропическом или garden-стиле.

Что входит в услугу:
• Озеленение террас и входных групп
• Цветочные композиции в кашпо
• Декоративные элементы (зонтики, фонарики)
• Тематические инсталляции
• Сезонное обслуживание растений`,
  gallery: [
  "/images/photo16.jpeg",
  "/images/photo13.jpeg",
  "/images/photo14.jpeg"],

},
{
  id: 6,
  slug: "autumn",
  title: "Осенний декор",
  description: "Теплая палитра и сезонные мотивы. Композиции с ветвями, листьями, акцентная подсветка.",
  image: "https://images.unsplash.com/photo-1761395043715-7b97f0cf5830?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxhdXR1bW4lMjBwdW1wa2luJTIwc3RvcmVmcm9udCUyMGRlY29yYXRpb258ZW58MHx8fHwxNzY5Nzk3NDIyfDA&ixlib=rb-4.1.0&q=85",
  color: "from-orange-600 to-amber-700",
  fullDescription: `Осеннее оформление — это тёплые краски, урожайные мотивы и уютная атмосфера. Идеально для оформления к 1 сентября, Дню учителя или просто для создания осеннего настроения.

Мы используем тыквы, осенние листья, сухоцветы, колосья и другие природные материалы в сочетании с декоративными элементами.

Что входит в услугу:
• Композиции с тыквами и природными материалами
• Осенние флористические композиции
• Декорирование сухоцветами и колосьями
• Тематические инсталляции
• Световое оформление в тёплых тонах`,
  gallery: [
  "https://images.unsplash.com/photo-1761395043715-7b97f0cf5830?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxhdXR1bW4lMjBwdW1wa2luJTIwc3RvcmVmcm9udCUyMGhhcnZlc3QlMjBkZWNvcmF0aW9ufGVufDB8fHx8MTc2OTc5OTYyN3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1542535547-b2b0c6d59682?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxhdXR1bW4lMjBwdW1wa2luJTIwc3RvcmVmcm9udCUyMGhhcnZlc3QlMjBkZWNvcmF0aW9ufGVufDB8fHx8MTc2OTc5OTYyN3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1634757701253-19522b371da6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxhdXR1bW4lMjBwdW1wa2luJTIwc3RvcmVmcm9udCUyMGhhcnZlc3QlMjBkZWNvcmF0aW9ufGVufDB8fHx8MTc2OTc5OTYyN3ww&ixlib=rb-4.1.0&q=85"],

}];


// Pricing data
const pricingPlans = [
{
  title: "Концепция и смета",
  price: "от 15 000 руб.",
  description: "Выезд и предложение",
  features: [
  "Выезд на объект",
  "Анализ входной группы и витрины",
  "Эскиз концепции",
  "Смета материалов и работ"],

  featured: false
},
{
  title: "Базовое оформление",
  price: "от 130 000 руб.",
  description: "Декор витрины, или входа",
  features: [
  "Концепция включена",
  "Базовые материалы",
  "Монтаж",
  "Демонтаж — опция (+15 000 руб.)",
  "Гарантия на сезон"],

  featured: false
},
{
  title: "Премиум декор",
  price: "от 180 000 руб.",
  description: "Авторский дизайн",
  features: [
  "Уникальная концепция",
  "Премиум материалы",
  "Монтаж и демонтаж",
  "3D-визуализация",
  "Полное сопровождение",
  "Поддержка в сезон"],

  featured: true
},
{
  title: "Сезонное переоформление",
  price: "от 60 000 руб.",
  description: "Обновление декора",
  features: [
  "Демонтаж старого декора",
  "Новая концепция",
  "Обновление материалов",
  "Быстрые сроки"],

  featured: false
}];


// Reviews data
const reviews = [
{
  id: 1,
  name: "Анна Михайлова",
  company: "Ресторан «Бирюза»",
  text: "Очень довольны новогодним оформлением. Гости останавливались у входа, фотографировались и делились в соцсетях. Вернемся за оформлением и в следующем сезоне.",
  rating: 5
},
{
  id: 2,
  name: "Дмитрий Соколов",
  company: "Бутик «Стиль»",
  text: "Профессиональная работа и сильный результат. Витрина стала заметнее, в праздничный период трафик и продажи выросли.",
  rating: 5
},
{
  id: 3,
  name: "Елена Ветрова",
  company: "Кофейня «Аромат»",
  text: "Работают быстро, аккуратно и с вниманием к деталям. Летнее оформление террасы стало точкой притяжения - гости постоянно фотографируются.",
  rating: 5
}];


// Navigation Component
const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
  { href: "#home", label: "Главная" },
  { href: "#decor-role", label: "Роль декора" },
  { href: "#services", label: "Услуги" },
  { href: "#about", label: "О нас" },
  { href: "#pricing", label: "Цены" },
  { href: "#reviews", label: "Отзывы" },
  { href: "#contact", label: "Контакты" }];


  const scrollToSection = (href) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? "glass shadow-lg py-3" : "glass py-5"}`
      }>

      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center">
        {/* Logo - centered and larger */}
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#home");
          }}
          className="hidden lg:block text-3xl lg:text-4xl font-bold font-['Playfair_Display'] text-stone-900 mb-3 italic"
          data-testid="logo-link">

          Сделай <span className="text-red-700">красиво!</span>
        </a>

        {/* Desktop Navigation - centered */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) =>
          <a
            key={link.href}
            href={link.href}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(link.href);
            }}
            className="nav-link text-sm uppercase tracking-wide"
            data-testid={`nav-${link.href.replace("#", "")}`}>

              {link.label}
            </a>
          )}
          <Button
            onClick={() => scrollToSection("#contact")}
            className="btn-primary ml-4"
            data-testid="nav-cta-button">

            Связаться
          </Button>
        </div>

        {/* Mobile: Logo centered, hamburger right */}
        <div className="lg:hidden w-full flex items-center justify-between">
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("#home");
            }}
            className="text-2xl font-bold font-['Playfair_Display'] text-stone-900 italic">

            Сделай <span className="text-red-700">красиво!</span>
          </a>
          <button
            className="p-2 text-stone-900"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-button">

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="lg:hidden glass mt-2 mx-4 rounded-2xl p-6" data-testid="mobile-menu">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) =>
          <a
            key={link.href}
            href={link.href}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(link.href);
            }}
            className="text-stone-900 font-medium py-2 border-b border-stone-200">

                {link.label}
              </a>
          )}
            <Button
            onClick={() => scrollToSection("#contact")}
            className="btn-primary mt-4">

              Связаться
            </Button>
          </div>
        </div>
      }
    </nav>);

};

// Hero Section
const HeroSection = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="min-h-screen relative overflow-hidden pt-20 lg:pt-0">

      {/* Background image - blurred */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(/images/hero-bg.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(7px)',
          opacity: 0.9,
          transform: 'scale(1.04)',
        }}
      />
      {/* Soft light overlay so content stays readable */}
      <div
        className="absolute inset-0 z-0 pointer-events-none"
        style={{
          background: 'linear-gradient(180deg, rgba(245,245,244,0.22) 0%, rgba(245,245,244,0.35) 60%, rgba(245,245,244,0.55) 100%)',
        }}
      />

      <div className="max-w-7xl mx-auto px-6 min-h-screen grid lg:grid-cols-2 gap-8 items-center relative z-10">
        {/* Left: Content */}
        <div className="relative z-10 py-12 lg:py-0">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-50 rounded-full mb-6 animate-fade-in-up">
            <Sparkles className="w-4 h-4 text-red-700" />
            <span className="text-red-700 text-sm font-medium">Сезонный декор для витрин и входных групп</span>
          </div>
          
          <h1 className="hero-title text-stone-900 mb-6 animate-fade-in-up stagger-1 italic">
            <span className="hero-underline">Сделай</span>
            <br />
            <span className="gradient-text">красиво!</span>
          </h1>
          
          <p className="text-lg text-stone-700 max-w-lg mb-8 animate-fade-in-up stagger-2 font-semibold">
            Оформляем входные группы, витрины и фасады для ресторанов, кофеен и магазинов. 
            Делаем концепцию, смету, закупку материалов, монтаж и демонтаж — чтобы вашу точку заметили с улицы и выбрали в сезон.
          </p>
          
          <div className="flex flex-wrap gap-4 animate-fade-in-up stagger-3">
            <a href="#contact" className="btn-primary gap-2">
              Получить расчет
              <ArrowRight className="w-4 h-4" />
            </a>
            <a href="#services" className="btn-secondary gap-2">
              Посмотреть услуги
              <ChevronRight className="w-4 h-4" />
            </a>
          </div>
          
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8 mt-12 animate-fade-in-up stagger-4">
            <div>
              <div className="text-xl font-bold text-stone-900">Под ключ</div>
              <div className="text-stone-700 text-sm font-semibold">Концепция, материалы, монтаж</div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-stone-200" />
            <div>
              <div className="text-xl font-bold text-stone-900">Смета до старта</div>
              <div className="text-stone-700 text-sm font-semibold">Понятный бюджет и состав работ</div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-stone-200" />
            <div>
              <div className="text-xl font-bold text-stone-900">Согласования</div>
              <div className="text-stone-700 text-sm font-semibold">Учитываем требования УК</div>
            </div>
          </div>
        </div>
        
        {/* Right: Images */}
        <div className="relative h-[500px] lg:h-[600px] animate-fade-in-up stagger-2">
          <div className="absolute top-0 right-0 w-[80%] h-[70%] rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="/images/photo1.jpeg"
              alt="Праздничный декор"
              className="w-full h-full object-cover object-center" />

          </div>
          <div className="absolute bottom-0 left-0 w-[60%] h-[50%] rounded-3xl overflow-hidden shadow-xl border-4 border-white">
            <img
              src="/images/photo3.jpeg"
              alt="Ночной декор"
              className="w-full h-full object-cover object-center" />

          </div>
        </div>
      </div>
    </section>);

};

// Decor Role Section
const DecorRoleSection = () => {
  const stats = [
    {
      value: "+30-50%",
      label: "притока посетителей",
      detail: "в кейсах с качественно оформленной витриной"
    },
    {
      value: "+20%",
      label: "роста пешеходного трафика",
      detail: "и +30% к длительности визита в украшенных торговых точках"
    },
    {
      value: "+15%",
      label: "к объёму продаж в сезон",
      detail: "в ТЦ с праздничным декором (по данным опроса Deloitte)"
    },
    {
      value: "10-15%",
      label: "рост среднего чека",
      detail: "в российской практике, при качественном новогоднем оформлении"
    }
  ];

  return (
    <section id="decor-role" data-testid="decor-role-section" className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="section-title text-stone-900 animate-fade-in-up">Роль декора</h2>
          <p className="section-subtitle mx-auto animate-fade-in-up stagger-1">
            Декор входной группы и витрины — это не только эстетика, но и прикладной инструмент, 
            который помогает привлекать внимание, увеличивать поток и повышать продажи в сезон.
          </p>
        </div>

        {/* Description */}
        <div className="max-w-4xl mx-auto mb-16 animate-fade-in-up stagger-2">
          <div className="bg-stone-50 rounded-3xl p-8 md:p-10 space-y-5 mb-8">
            <p className="text-stone-600 font-light leading-relaxed">
              В офлайн-бизнесе решение часто принимается на улице. Люди видят фасад, витрину, вход, 
              и за несколько секунд выбирают — зайти к вам или пройти дальше. Сезонный декор работает 
              как визуальная реклама, которая выделяет точку на фоне соседей и даёт повод остановиться, 
              рассмотреть и сделать фото.
            </p>
            <p className="text-stone-600 font-light leading-relaxed">
              Декор особенно полезен в периоды, когда усиливается конкуренция за внимание — например, 
              в декабре, к 8 Марта, в сезон распродаж и городских праздников. Он создаёт настроение, 
              повышает вовлечённость, увеличивает время пребывания, а это повышает вероятность покупки 
              и средний чек.
            </p>
          </div>
          <p className="text-stone-500 text-sm font-light leading-relaxed italic px-8 md:px-10">
            Мы опираемся не на обещания, а на данные отраслевых исследований и кейсов, 
            собранных по России и международной практике.
          </p>
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="decor-stat-card animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
              data-testid={`decor-stat-${index}`}
            >
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">{stat.value}</div>
              <div className="text-emerald-100 font-medium text-sm mb-2">{stat.label}</div>
              <div className="text-emerald-200/70 text-xs">{stat.detail}</div>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <p className="text-center text-stone-400 text-sm max-w-3xl mx-auto mb-8">
          Цифры основаны на открытых исследованиях и кейсах. Фактический эффект зависит от локации, 
          предложения, сервиса и того, как бизнес монетизирует выросший интерес.
        </p>

        {/* PDF Link */}
        <div className="text-center">
          <a
            href="https://disk.yandex.ru/i/KB00EGCDwtKHig"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary gap-2 inline-flex"
            data-testid="decor-pdf-link"
          >
            Смотреть исследование (PDF)
            <ArrowRight className="w-4 h-4" />
          </a>
          <p className="text-stone-400 text-sm mt-3">
            Сводка данных и источников по России и международной практике
          </p>
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="section-title text-stone-900 animate-fade-in-up">Наши услуги</h2>
          <p className="section-subtitle mx-auto animate-fade-in-up stagger-1">
            Сезонное оформление под ключ — под праздник, сезон и стиль вашего бренда
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) =>
          <Link
            to={`/services/${service.slug}`}
            key={service.id}
            className={`service-card h-[350px] ${service.large ? "md:col-span-2 lg:col-span-1" : ""} animate-fade-in-up cursor-pointer`}
            style={{ animationDelay: `${index * 0.1}s` }}
            data-testid={`service-card-${service.id}`}>

              <img
              src={service.image}
              alt={service.title}
              className="service-card-image w-full h-full object-cover absolute inset-0" />

              <div className="service-card-overlay" />
              <div className="relative h-full flex flex-col justify-end p-6 text-white">
                <h3 className="text-2xl font-semibold mb-2 font-['Playfair_Display']">
                  {service.title}
                </h3>
                <p className="text-white/80 font-light italic">{service.description}</p>
                <div className="mt-3 flex items-center gap-2 text-white/90 text-sm font-medium">
                  Подробнее <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    </section>);

};

// About Section
const AboutSection = () => {
  const [workLightbox, setWorkLightbox] = useState(false);
  const [workIndex, setWorkIndex] = useState(0);
  const workPhotos = [
    { src: "/images/work3.jpeg", alt: "Подготовка материалов" },
    { src: "/images/work2.jpeg", alt: "Монтаж каркаса" },
    { src: "/images/work1.jpeg", alt: "Готовый декор" },
    { src: "/images/photo15.jpeg", alt: "Результат — летний декор" },
    { src: "/images/photo16.jpeg", alt: "Результат — цветочная композиция" },
    { src: "/images/photo13.jpeg", alt: "Результат — декор входной группы" },
  ];

  return (
    <section id="about" data-testid="about-section" className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="section-title text-stone-900">О нас</h2>
          <p className="section-subtitle mx-auto">
            Мы — студия сезонного оформления входных групп, витрин и фасадов
          </p>
        </div>
        
        {/* Main content - image + intro */}
        <div className="grid lg:grid-cols-5 gap-12 items-center mb-16">
          {/* Image - takes 2 columns */}
          <div className="lg:col-span-2 relative">
            <div className="image-zoom">
              <img
                src="/images/about-team.jpeg"
                alt="Наталья Бондарева и Мария Виноградова за работой над концепцией"
                className="w-full h-[400px] object-cover rounded-3xl" />

            </div>
            <div className="absolute -bottom-6 -right-6 lg:-right-8 bg-red-700 rounded-2xl flex items-center justify-center text-white px-6 py-4 shadow-xl">
              <div className="text-center">
                <div className="text-3xl font-bold">30+</div>
                <div className="text-xs font-light">лет в коммерции</div>
              </div>
            </div>
          </div>
          
          {/* Founders info - takes 3 columns */}
          <div className="lg:col-span-3">
            <p className="text-lg text-stone-600 mb-8 font-light leading-relaxed">
              В команде работают профессиональные декораторы и флористы, которые воплощают каждый проект от эскиза до монтажа. 
              Совладелицы, <span className="font-medium text-stone-900">Наталья Бондарева</span> и <span className="font-medium text-stone-900">Мария Виноградова</span> — имеют свыше 30 лет совместного опыта в управлении коммерческой недвижимостью и развитии сетевого ритейла. 
              Они знают как сделать ваш объект более заметным и интересным для посетителей.
            </p>
            
            {/* Founders cards */}
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              <div className="p-5 bg-stone-50 rounded-2xl">
                <div className="flex items-center gap-4 mb-3">
                  <img src="/images/natalia.jpeg" alt="Наталья Бондарева" className="w-16 h-16 rounded-full object-cover object-top" />
                  <div className="font-semibold text-stone-900">Наталья Бондарева</div>
                </div>
                <p className="!text-sm text-stone-600">Ведущий менеджер по аренде в крупнейшей в Санкт-Петербурге сети ТРК. 
Взаимодействовала с ритейл-брендами, ресторанами и операторами фастфуда.
                </p>
              </div>
              <div className="p-5 bg-stone-50 rounded-2xl">
                <div className="flex items-center gap-4 mb-3">
                  <img src="/images/maria.jpeg" alt="Мария Виноградова" className="w-16 h-16 rounded-full object-cover object-top" />
                  <div className="font-semibold text-stone-900">Мария Виноградова</div>
                </div>
                <p className="!text-sm text-stone-600">Менеджер по развитию крупных сетевых ритейлеров. Понимает задачи рител-бизнеса изнутри.

                </p>
              </div>
            </div>
            
            <p className="text-stone-600 font-light leading-relaxed mb-8">
              Этот опыт помогает смотреть на декор как на прикладной инструмент — чтобы он привлекал покупателей, 
              поддерживал рост выручки и соответствовал требованиям управляющих компаний.
            </p>

            {/* Behind the scenes */}
            <div>
              <h4 className="text-sm font-semibold text-stone-500 uppercase tracking-wider mb-4">Как мы работаем</h4>
              <div className="grid grid-cols-3 gap-3">
                {workPhotos.slice(0, 3).map((photo, idx) => (
                  <img 
                    key={idx}
                    src={photo.src} 
                    alt={photo.alt} 
                    className="w-full h-32 object-cover rounded-xl cursor-pointer hover:opacity-80 transition-opacity" 
                    onClick={() => { setWorkIndex(idx); setWorkLightbox(true); }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        
        {/* Features grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-stone-100">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
              <Check className="w-5 h-5 text-emerald-700" />
            </div>
            <div>
              <div className="font-semibold text-stone-900 text-sm">Концепция под ваш бренд</div>
              <div className="text-xs text-stone-500 mt-1">Оформление в стиле вашей точки</div>
            </div>
          </div>
          <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-stone-100">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
              <Check className="w-5 h-5 text-emerald-700" />
            </div>
            <div>
              <div className="font-semibold text-stone-900 text-sm">Материалы и крепеж</div>
              <div className="text-xs text-stone-500 mt-1">Проверенные поставщики</div>
            </div>
          </div>
          <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-stone-100">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
              <Check className="w-5 h-5 text-emerald-700" />
            </div>
            <div>
              <div className="font-semibold text-stone-900 text-sm">Смета и сроки до старта</div>
              <div className="text-xs text-stone-500 mt-1">Без сюрпризов по бюджету</div>
            </div>
          </div>
          <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-stone-100">
            <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
              <Check className="w-5 h-5 text-emerald-700" />
            </div>
            <div>
              <div className="font-semibold text-stone-900 text-sm">От замера до демонтажа</div>
              <div className="text-xs text-stone-500 mt-1">Полное сопровождение</div>
            </div>
          </div>
        </div>
        
        {/* CTA */}
        <div className="text-center">
          <a href="#contact" className="btn-primary inline-flex gap-2">
            Обсудить проект
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>

      {/* Work Lightbox */}
      {workLightbox && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
          onClick={() => setWorkLightbox(false)}
        >
          <button 
            className="absolute top-6 right-6 text-white/80 hover:text-white"
            onClick={() => setWorkLightbox(false)}
          >
            <X className="w-8 h-8" />
          </button>
          <button 
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-black/30 rounded-full p-2"
            onClick={(e) => { e.stopPropagation(); setWorkIndex((workIndex - 1 + workPhotos.length) % workPhotos.length); }}
          >
            <ChevronLeft className="w-8 h-8" />
          </button>
          <img 
            src={workPhotos[workIndex].src} 
            alt={workPhotos[workIndex].alt}
            className="max-h-[85vh] max-w-[90vw] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <button 
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-black/30 rounded-full p-2"
            onClick={(e) => { e.stopPropagation(); setWorkIndex((workIndex + 1) % workPhotos.length); }}
          >
            <ChevronRight className="w-8 h-8" />
          </button>
          <div className="absolute bottom-6 text-white/60 text-sm">
            {workPhotos[workIndex].alt} — {workIndex + 1} / {workPhotos.length}
          </div>
        </div>
      )}
    </section>);
};

// Pricing Section
const PricingSection = () => {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="section-title text-stone-900 animate-fade-in-up">Цены</h2>
          <p className="section-subtitle mx-auto animate-fade-in-up stagger-1">
            Прозрачные пакеты и понятный состав работ, без скрытых платежей
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingPlans.map((plan, index) =>
          <div
            key={plan.title}
            className={`pricing-card ${plan.featured ? "featured" : ""} animate-fade-in-up`}
            style={{ animationDelay: `${index * 0.1}s` }}
            data-testid={`pricing-card-${index}`}>

              {plan.featured &&
            <div className="absolute -top-3 left-8 px-3 py-1 bg-amber-500 text-white text-xs font-medium rounded-full shadow-md" data-testid="pricing-popular-badge">
                  Популярный
                </div>
            }
              <h3 className={`text-xl font-semibold mb-2 font-['Playfair_Display'] ${plan.featured ? "text-white" : "text-stone-900"}`}>
                {plan.title}
              </h3>
              <p className={`text-sm mb-4 italic ${plan.featured ? "text-emerald-200" : "text-stone-500"}`}>
                {plan.description}
              </p>
              <div className={`text-3xl font-bold mb-6 ${plan.featured ? "text-white" : "text-stone-900"}`}>
                {plan.price}
              </div>
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature) =>
              <li key={feature} className="flex items-center gap-2">
                    <Check className={`w-4 h-4 ${plan.featured ? "text-emerald-300" : "text-emerald-600"}`} />
                    <span className={`text-sm ${plan.featured ? "text-emerald-100" : "text-stone-600"}`}>
                      {feature}
                    </span>
                  </li>
              )}
              </ul>
              <Button
              className={`w-full rounded-full ${
              plan.featured ?
              "bg-white text-emerald-800 hover:bg-emerald-50" :
              "bg-stone-900 text-white hover:bg-stone-800"}`
              }
              onClick={() => {
                const contactSection = document.querySelector("#contact");
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: "smooth" });
                }
              }}>

                Заказать
              </Button>
            </div>
          )}
        </div>
      </div>
    </section>);

};

// Reviews Section
const ReviewsSection = () => {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="section-title text-stone-900 animate-fade-in-up">Отзывы клиентов</h2>
          <p className="section-subtitle mx-auto animate-fade-in-up stagger-1">
            Что говорят о работе с нами
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, index) =>
          <Card
            key={review.id}
            className="review-card border-0 animate-fade-in-up"
            style={{ animationDelay: `${index * 0.1}s` }}
            data-testid={`review-card-${review.id}`}>

              <CardContent className="p-0">
                <div className="flex gap-1 mb-4">
                  {[...Array(review.rating)].map((_, i) =>
                <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                )}
                </div>
                <p className="text-stone-600 mb-6 font-accent text-lg italic leading-relaxed">
                  "{review.text}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-600 to-pink-600 flex items-center justify-center text-white font-semibold">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-semibold text-stone-900">{review.name}</div>
                    <div className="text-sm text-stone-500">{review.company}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </section>);

};

// Contact Section
const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Сообщение отправлено! Мы свяжемся с вами в ближайшее время.");
      setFormData({ name: "", phone: "", email: "", message: "" });
    } catch (error) {
      toast.error("Произошла ошибка. Попробуйте позвонить нам напрямую.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Contact Info */}
          <div>
            <h2 className="section-title text-stone-900 mb-6">Свяжитесь с нами</h2>
            <p className="text-lg text-stone-600 mb-8 font-light">
              Оставьте заявку, и мы предложим 1-2 варианта концепции и предварительную смету. 
              Ответим в рабочее время.
            </p>
            
            <div className="space-y-6 mb-8">
              <a
                href="tel:+79317057065"
                className="flex items-center gap-4 p-4 bg-white rounded-2xl hover:shadow-md transition-shadow"
                data-testid="contact-phone">

                <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                  <Phone className="w-5 h-5 text-red-700" />
                </div>
                <div>
                  <div className="text-sm text-stone-500">Телефон</div>
                  <div className="font-semibold text-stone-900">+7 (931) 705-70-65</div>
                </div>
              </a>
              
              <a
                href="mailto:natalia@makeusbeautiful.ru"
                className="flex items-center gap-4 p-4 bg-white rounded-2xl hover:shadow-md transition-shadow"
                data-testid="contact-email">

                <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-red-700" />
                </div>
                <div>
                  <div className="text-sm text-stone-500">Email</div>
                  <div className="font-semibold text-stone-900">natalia@makeusbeautiful.ru</div>
                </div>
              </a>
              
              <a
                href="https://t.me/natali_ro"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 bg-gradient-to-r from-sky-500 to-blue-600 rounded-2xl hover:shadow-lg transition-shadow text-white"
                data-testid="contact-telegram">

                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                  <Send className="w-5 h-5 text-white" />
                </div>
                <div>
                  <div className="text-sm text-sky-100">Telegram</div>
                  <div className="font-semibold">Написать в Telegram</div>
                </div>
              </a>
            </div>
            
            <div className="p-6 bg-emerald-800 rounded-2xl text-white">
              <h3 className="text-xl font-semibold mb-2 font-['Playfair_Display']">
                Бесплатная консультация
              </h3>
              <p className="text-emerald-100 font-light">
                Подскажем, какое оформление подойдет вашему объекту, как уложиться в бюджет и что обычно согласуют управляющие компании.
              </p>
            </div>
          </div>
          
          {/* Contact Form */}
          <div className="bg-white p-8 rounded-3xl shadow-sm">
            <h3 className="text-2xl font-semibold mb-6 font-['Playfair_Display'] text-stone-900">
              Получить расчет
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
              <div>
                <Input
                  placeholder="Ваше имя"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="form-input"
                  required
                  data-testid="contact-name-input" />

              </div>
              <div>
                <Input
                  type="tel"
                  placeholder="Телефон"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="form-input"
                  required
                  data-testid="contact-phone-input" />

              </div>
              <div>
                <Input
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="form-input"
                  data-testid="contact-email-input" />

              </div>
              <div>
                <Textarea
                  placeholder="Коротко о задаче и объекте"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="form-input min-h-[120px] resize-none"
                  rows={4}
                  data-testid="contact-message-input" />

              </div>
              <Button
                type="submit"
                className="w-full btn-primary"
                disabled={isSubmitting}
                data-testid="contact-submit-button">

                {isSubmitting ? "Отправка..." : "Отправить заявку"}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>);

};

// Footer Component
const Footer = () => {
  return (
    <footer className="py-12 bg-stone-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <Link to="/" className="text-2xl font-bold font-['Playfair_Display'] mb-2 block italic">
              Сделай <span className="text-red-500">красиво!</span>
            </Link>
            <p className="text-stone-400 text-sm">
              Студия сезонного декора для витрин, входных групп и фасадов
            </p>
          </div>
          
          <div className="flex items-center gap-6">
            <a href="tel:+79317057065" className="footer-link text-stone-300 hover:text-white">
              +7 (931) 705-70-65
            </a>
            <a href="mailto:natalia@makeusbeautiful.ru" className="footer-link text-stone-300 hover:text-white">
              natalia@makeusbeautiful.ru
            </a>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-stone-800 text-center text-stone-500 text-sm">
          © {new Date().getFullYear()} Сделай красиво! Все права защищены.
        </div>
      </div>
    </footer>);

};

// Service Detail Page
const ServiceDetailPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = services.find((s) => s.slug === slug);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  // Close lightbox on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setLightboxOpen(false);
      if (e.key === 'ArrowRight' && lightboxOpen) {
        setCurrentImageIndex((prev) => (prev + 1) % (service?.gallery?.length || 1));
      }
      if (e.key === 'ArrowLeft' && lightboxOpen) {
        setCurrentImageIndex((prev) => (prev - 1 + (service?.gallery?.length || 1)) % (service?.gallery?.length || 1));
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, service?.gallery?.length]);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  // Touch handlers for swipe
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      // Swipe left = next image
      setCurrentImageIndex((prev) => (prev + 1) % (service?.gallery?.length || 1));
    }
    if (isRightSwipe) {
      // Swipe right = previous image
      setCurrentImageIndex((prev) => (prev - 1 + (service?.gallery?.length || 1)) % (service?.gallery?.length || 1));
    }
  };

  if (!service) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Услуга не найдена</h1>
          <Link to="/" className="btn-primary inline-flex">На главную</Link>
        </div>
      </div>);

  }

  return (
    <div className="min-h-screen bg-stone-50">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 glass shadow-lg py-4">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold font-['Playfair_Display'] text-stone-900 italic">
            Сделай <span className="text-red-700">красиво!</span>
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors">

            <ArrowLeft className="w-4 h-4" />
            На главную
          </Link>
        </div>
      </header>
      
      {/* Hero */}
      <section className="pt-24 pb-12">
        <div className="relative h-[50vh] min-h-[400px]">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover" />

          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
            <div className="max-w-7xl mx-auto">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white font-['Playfair_Display'] mb-4">
                {service.title}
              </h1>
              <p className="text-xl text-white/80 max-w-2xl">{service.description}</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Description */}
            <div>
              <h2 className="text-3xl font-semibold font-['Playfair_Display'] text-stone-900 mb-6">
                О услуге
              </h2>
              <div className="prose prose-lg text-stone-600">
                {service.fullDescription.split('\n\n').map((paragraph, idx) =>
                <p key={idx} className={`mb-4 font-light leading-relaxed whitespace-pre-line ${paragraph.startsWith('Что входит') ? '' : 'italic'}`}>
                    {paragraph.startsWith('Что входит') ? 
                      <>{<strong className="font-semibold text-stone-900 not-italic">{paragraph.split('\n')[0]}</strong>}{'\n'}<span className="not-italic">{paragraph.split('\n').slice(1).join('\n')}</span></> : 
                      paragraph}
                  </p>
                )}
              </div>
              
              <div className="mt-10 flex flex-wrap gap-4">
                <Link
                  to="/"
                  state={{ scrollTo: 'contact' }}
                  className="btn-primary gap-2">

                  Заказать услугу
                  <ArrowRight className="w-4 h-4" />
                </Link>
                <a href="tel:+79317057065" className="btn-secondary gap-2">
                  <Phone className="w-4 h-4" />
                  Позвонить
                </a>
              </div>
            </div>
            
            {/* Gallery */}
            <div>
              <h2 className="text-3xl font-semibold font-['Playfair_Display'] text-stone-900 mb-6">
                Примеры работ
              </h2>
              <div className="grid grid-cols-2 gap-4">
                {service.gallery.map((img, idx) =>
                <div
                  key={idx}
                  onClick={() => openLightbox(idx)}
                  className={`rounded-2xl overflow-hidden cursor-pointer ${idx === 0 ? 'col-span-2 h-[300px]' : 'h-[200px]'}`}>

                    <img
                    src={img}
                    alt={`${service.title} пример ${idx + 1}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />

                  </div>
                )}
              </div>
              <p className="text-sm text-stone-400 mt-3 text-center">Нажмите на фото для увеличения</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Other Services */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-semibold font-['Playfair_Display'] text-stone-900 mb-8 text-center">
            Другие услуги
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {services.filter((s) => s.slug !== slug).slice(0, 5).map((s) =>
            <Link
              key={s.id}
              to={`/services/${s.slug}`}
              className="group relative h-[200px] rounded-2xl overflow-hidden">

                <img
                src={s.image}
                alt={s.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white font-semibold text-sm">{s.title}</h3>
                </div>
              </Link>
            )}
          </div>
        </div>
      </section>
      
      {/* Lightbox Modal */}
      {lightboxOpen &&
      <div
        className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center"
        onClick={() => setLightboxOpen(false)}>

          {/* Close button */}
          <button
          onClick={() => setLightboxOpen(false)}
          className="absolute top-6 right-6 text-white/80 hover:text-white transition-colors z-10"
          data-testid="lightbox-close">

            <X className="w-8 h-8" />
          </button>
          
          {/* Image counter */}
          <div className="absolute top-6 left-6 text-white/80 text-sm">
            {currentImageIndex + 1} / {service.gallery.length}
          </div>
          
          {/* Previous button - hidden on mobile */}
          <button
          onClick={(e) => {
            e.stopPropagation();
            setCurrentImageIndex((prev) => (prev - 1 + service.gallery.length) % service.gallery.length);
          }}
          className="absolute left-4 md:left-8 text-white/80 hover:text-white transition-colors p-2 hidden md:block"
          data-testid="lightbox-prev">

            <ArrowLeft className="w-8 h-8" />
          </button>
          
          {/* Main image */}
          <div
          className="max-h-[85vh] max-w-[90vw] flex items-center justify-center"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          onClick={(e) => e.stopPropagation()}>

            <img
            src={service.gallery[currentImageIndex]}
            alt={`${service.title} пример ${currentImageIndex + 1}`}
            className="max-h-[85vh] max-w-[90vw] object-contain rounded-lg select-none"
            draggable="false" />

          </div>
          
          {/* Next button - hidden on mobile */}
          <button
          onClick={(e) => {
            e.stopPropagation();
            setCurrentImageIndex((prev) => (prev + 1) % service.gallery.length);
          }}
          className="absolute right-4 md:right-8 text-white/80 hover:text-white transition-colors p-2 hidden md:block"
          data-testid="lightbox-next">

            <ArrowRight className="w-8 h-8" />
          </button>
          
          {/* Swipe hint for mobile */}
          <div className="absolute bottom-20 left-1/2 -translate-x-1/2 text-white/50 text-xs md:hidden">
            ← Свайпните для переключения →
          </div>
          
          {/* Thumbnails */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
            {service.gallery.map((img, idx) =>
          <button
            key={idx}
            onClick={(e) => {
              e.stopPropagation();
              setCurrentImageIndex(idx);
            }}
            className={`w-16 h-12 rounded-lg overflow-hidden border-2 transition-all ${
            idx === currentImageIndex ? 'border-white scale-110' : 'border-transparent opacity-60 hover:opacity-100'}`
            }>

                <img src={img} alt="" className="w-full h-full object-cover" />
              </button>
          )}
          </div>
        </div>
      }
      
      <Footer />
    </div>);

};

// Home Page Component
const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if we need to scroll to contact section
    if (location.state?.scrollTo === 'contact') {
      // Wait for page to fully render
      const timer = setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <>
      <Navigation />
      <main>
        <HeroSection />
        <DecorRoleSection />
        <ServicesSection />
        <AboutSection />
        <PricingSection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
    </>);

};

// Main App Component
function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen">
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
        </Routes>
      </div>
    </BrowserRouter>);

}

export default App;